import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Button, Paper, Stack, Typography,
} from '@mui/material';
import { request } from './OperationsProvider';
import { formatDateTime } from '../common/util/datetime';

// Reads the briefing the scheduler wrote for yesterday. Nothing is computed here: the figures were
// settled once, for the day they describe, so everyone opening this page reads the same account of
// the same day. An absent briefing shows nothing at all rather than an empty box - a plant that has
// not run yet has nothing to report.
const tone = {
  error: { dot: 'error.main', weight: 600 },
  warning: { dot: 'warning.main', weight: 600 },
  info: { dot: 'text.disabled', weight: 400 },
};

const BriefingPanel = () => {
  const navigate = useNavigate();
  const [briefing, setBriefing] = useState(null);
  useEffect(() => {
    const controller = new AbortController();
    request('/api/operations/briefing', 'GET', null, controller.signal)
      .then((result) => setBriefing(result?.findings?.length ? result : null))
      .catch(() => {});
    return () => controller.abort();
  }, []);
  if (!briefing) return null;
  return (
    <Paper variant="outlined" sx={{ p: 2.5, mb: 3 }}>
      <Typography variant="overline" color="primary" sx={{ display: 'block', letterSpacing: 1 }}>ZENY</Typography>
      <Stack direction="row" alignItems="baseline" gap={1} flexWrap="wrap" sx={{ mb: 1.5 }}>
        <Typography variant="h6">{`Yesterday, ${new Date(`${briefing.day}T00:00:00`).toLocaleDateString(undefined, { day: 'numeric', month: 'long' })}`}</Typography>
        <Typography variant="caption" color="text.secondary">{`Prepared ${formatDateTime(briefing.generatedAt)}`}</Typography>
      </Stack>
      <Stack spacing={1}>
        {briefing.findings.map((finding) => (
          <Stack key={finding.key} direction="row" alignItems="center" gap={1.5}>
            <Box sx={{
              width: 8, height: 8, borderRadius: '50%', bgcolor: (tone[finding.severity] || tone.info).dot, flexShrink: 0,
            }}
            />
            <Typography variant="body2" sx={{ fontWeight: (tone[finding.severity] || tone.info).weight, flex: 1, minWidth: 0 }}>
              {finding.text}
            </Typography>
            {finding.actionTo && (
              <Button size="small" sx={{ whiteSpace: 'nowrap', flexShrink: 0 }} onClick={() => navigate(finding.actionTo)}>
                {finding.actionLabel}
              </Button>
            )}
          </Stack>
        ))}
      </Stack>
    </Paper>
  );
};

export default BriefingPanel;
